import React, { memo, useEffect, useState } from 'react';
import chroma from 'chroma-js';
import { LazyLoadPlaceholder } from '../../../';
import { SlideImageWrapper } from './Hero.Styles';
import { useTheme } from '@web/theme';
export var SlideImage = memo(function (_a) {
    var isFetching = _a.isFetching, images = _a.images, size = _a.size;
    var theme = useTheme();
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    useEffect(function () {
        if (!isFetching)
            setIsLoaded(false);
    }, [isFetching]);
    var onLoad = function () { return !isLoaded && setIsLoaded(true); };
    return (React.createElement(SlideImageWrapper, { size: size },
        isFetching &&
            React.createElement(LazyLoadPlaceholder, null),
        React.createElement("div", { style: {
                backgroundImage: "linear-gradient(to bottom, " + chroma(theme.page.bg).alpha(0).hex() + " 30%, " + theme.page.bg + "), url(" + images + ")",
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }, onLoad: onLoad })));
});
